import { useTrackingCoreWebVitalEvents } from './useTrackingCoreWebVitalEvents'

const CoreWebVitalsGlobal = () => {
	useTrackingCoreWebVitalEvents()
}

export default CoreWebVitalsGlobal
